import React from "react";
import Table from "../../../material-ui/table";
import {sortKeysIgnoreCase} from "../../../../utils";
import {PackageContext} from "../package-context";
import { FILTER_KEYS_NAME_REPLACEMENT_FULL_DETAILS_TAB } from "variables/consult-info";

export const CreateFullDetailList = (_package) => {
  const infoData = (_package || {}).info || {};

  const fixedKeys = Object.keys(FILTER_KEYS_NAME_REPLACEMENT_FULL_DETAILS_TAB);

  return fixedKeys
    .map((fixedKey) => {
      
      const displayName = FILTER_KEYS_NAME_REPLACEMENT_FULL_DETAILS_TAB[fixedKey];
      
      const valueFromPackage = infoData[fixedKey];
      
      const finalValue = valueFromPackage || '';

      return {
        name: displayName, 
        value: [
          displayName,
          finalValue
        ]
      }
    });
};

export const FullDetailsTab = () => {
    const {_package} = React.useContext(PackageContext);
    const detail_list = CreateFullDetailList(_package);
    detail_list.sort( (a, b) => a.value[0].localeCompare(b.value[0], 'fr', { ignorePunctuation: true }));
    return <Table rows={detail_list}/>
};

export default FullDetailsTab;

